import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=b65f8a32&scoped=true"
import script from "./TopBanner.vue?vue&type=script&lang=js"
export * from "./TopBanner.vue?vue&type=script&lang=js"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=b65f8a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65f8a32",
  null
  
)

export default component.exports